import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c777a37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brush-map__actions" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Зубная нить ")
const _hoisted_3 = {
  key: 1,
  class: "firm__button"
}
const _hoisted_4 = {
  key: 2,
  class: "firm__button--curaprox"
}

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import IconTemplate from '@/apps/components/IconTemplate.vue'
import { BrushMapFirm } from '../brushMapFirm'

interface Props {
  brushMapFirm: BrushMapFirm
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapFirm: null
  },
  emits: ['openTipWindow', 'changeDentalFlossMode'],
  setup(__props: any, { emit }) {




const route = useRoute()
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const isDentalFlossMode = ref(false)

const changeDentalFlossMode = () => {
  isDentalFlossMode.value = !isDentalFlossMode.value
  emit('changeDentalFlossMode', isDentalFlossMode.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'brush-map__header_preview': _unref(isPreviewMode) }, "brush-map__header"])
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass([{ 'brush-map__title_preview': _unref(isPreviewMode) }, "brush-map__title"])
    }, " LUNA ", 2),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_checkbox_button, { onChange: changeDentalFlossMode }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 512), [
        [_vShow, !_unref(isPreviewMode)]
      ]),
      (!_unref(isPreviewMode))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openTipWindow')))
          }, [
            _createVNode(IconTemplate, {
              height: "25",
              name: "tip",
              width: "25"
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(isPreviewMode) && __props.brushMapFirm.firm.nameFirm !== 'Curaprox')
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.brushMapFirm.firm.nameFirm), 1))
        : (_unref(isPreviewMode))
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.brushMapFirm.firm.nameFirm), 1))
          : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})